import { useAuth0 } from "@auth0/auth0-react";
import { MoreVertical } from "lucide-react";

import { useTranslation } from "@punto/frontend-shared/i18n/i18next";
import { Button } from "@punto/ui/components/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@punto/ui/components/dropdown-menu";

export const SidebarHeader = () => {
  const { t } = useTranslation();
  const { logout } = useAuth0();

  return (
    <div className="flex items-center justify-between border-b bg-white p-3">
      <div className="flex-1" />
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="sm" className="h-8 w-8 p-0">
            <MoreVertical className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem
            onClick={() => {
              void logout({
                logoutParams: { returnTo: window.location.origin },
              });
            }}
          >
            {t("SidebarScreen.actions.logout")}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
